<template>
  <div class="flex flex-col">
    <SectionsHeader v-if="isSearch" :is-demo="isDemo" :filters.sync="filters" />

    <SectionsChips
      v-if="isFilters"
      class="mb-4"
      :filters.sync="filters"
      :filtered-sections="filteredSections"
      :sections="sections.list"
    />

    <div class="px-4 sm:px-8 flex flex-col">
      <SectionsList :list="filteredSections" />

      <div v-if="filteredSections.length > 0" class="py-8">
        <BaseButton v-if="isBackToTopButton" @click="handleBackToStart">
          <div class="gap-4 flex">
            <span>{{ $t('hub.sections.backToTop') }}</span>
            <BaseIcon icon="angle-up" />
          </div>
        </BaseButton>
      </div>

      <div v-else class="px-4 sm:px-8 py-8 pt-4">
        <div
          class="gap-4 flex flex-col items-center justify-center text-[#7C7C7C]"
        >
          <BaseIcon icon="not-found-magnifying-glass" class="text-3xl" />

          <div class="flex flex-col items-center justify-center">
            <span class="text-base font-bold">{{
              $t('hub.sections.nothingFound')
            }}</span>
            <span class="text-sm">{{
              $t('hub.sections.clearSearchAndTryAgain')
            }}</span>
          </div>

          <div>
            <BaseButton class="mt-4" size="small" @click="handleClearSearch">
              {{ $t('hub.sections.clearSearch') }}
            </BaseButton>
          </div>
        </div>
      </div>
    </div>

    <LandingFooter v-if="!isDemo" />
  </div>
</template>

<script>
import { mapState } from 'vuex'

import BaseButton from '@/components/Base/BaseButton.vue'
import BaseIcon from '@/components/Base/BaseIcon.vue'

import SectionsHeader from '@/components/Hub/Sections/SectionsHeader.vue'
import SectionsChips from '@/components/Hub/Sections/SectionsChips.vue'
import SectionsList from '@/components/Hub/Sections/SectionsList.vue'

import LandingFooter from '@/components/Landing/LandingFooter.vue'

export default {
  name: 'HubSections',

  components: {
    BaseButton,
    BaseIcon,

    SectionsHeader,
    SectionsChips,
    SectionsList,

    LandingFooter
  },

  provide() {
    return {
      isStars: this.isStars,
      isReadonly: this.isReadonly,
      isRandomStars: this.isRandomStars
    }
  },

  props: {
    isDemo: { type: Boolean, default: false },
    isStars: { type: Boolean, default: true },
    isReadonly: { type: Boolean, default: false },
    isRandomStars: { type: Boolean, default: false },
    isBackToTopButton: { type: Boolean, default: true },

    isSearch: { type: Boolean, default: true },
    isFilters: { type: Boolean, default: true }
  },

  data: () => ({
    filters: {
      search: '',
      sectionSlug: 'all'
    }
  }),

  computed: {
    ...mapState('sections', ['sections']),

    filteredSections() {
      let list = this.sections.list.filter(
        section => !['tutorial', 'playground'].includes(section.slug)
      )

      if (this.filters.sectionSlug !== 'all') {
        list = list.filter(section => section.slug === this.filters.sectionSlug)
      }

      const searchTerm = this.filters.search.toLowerCase()

      list = list.reduce((acc, section) => {
        const topics = section.topics.filter(topic =>
          topic.name.toLowerCase().includes(searchTerm)
        )
        if (topics.length) acc.push({ ...section, topics })
        return acc
      }, [])

      return list
    }
  },

  methods: {
    handleBackToStart() {
      let scrollableElement = this.$el

      while (scrollableElement && scrollableElement !== document.body) {
        const style = window.getComputedStyle(scrollableElement)
        const overflowY = style.overflowY
        const overflow = style.overflow

        if (
          overflowY === 'auto' ||
          overflowY === 'scroll' ||
          overflow === 'auto' ||
          overflow === 'scroll'
        ) {
          if (
            scrollableElement.scrollHeight - scrollableElement.clientHeight >
            scrollableElement.clientHeight * 2
          ) {
            scrollableElement.scrollTo({
              top: 0,
              behavior: 'smooth'
            })
            return
          }
        }

        scrollableElement = scrollableElement.parentElement
      }

      // Fallback to window scrolling
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },

    handleClearSearch() {
      this.filters = { ...this.filters, search: '' }
    }
  }
}
</script>
